(() => {
  'use strict';
  const dialog = document.querySelector('[data-news-dialog]');

  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'miveka-newsletter-dismissed-v1';
  const subscribedKey = 'miveka-newsletter-subscribed-v1';
  let previousFocus;
  let previousOverflow;
  const read = key => { try { return localStorage.getItem(key); } catch (_) { return null; } };
  const write = (key, value) => { try { localStorage.setItem(key, value); } catch (_) {} };
  const open = () => {
    if (dialog.open) return;
    previousFocus = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    (dialog.querySelector('[data-news-success], [data-news-error]') || dialog.querySelector('[data-news-close]')).focus();
  };
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow || '';
    write(key, String(Date.now()));
    previousFocus?.focus();
  });


  dialog.querySelector('[data-news-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  if (dialog.querySelector('[data-news-success]')) {
    write(subscribedKey, 'true');
    open();
  } else if (dialog.querySelector('[data-news-error]')) {
    open();
  } else if (dialog.dataset.auto === 'true' && read(subscribedKey) !== 'true' && Date.now() - Number(read(key) || 0) > 7 * 86400000) {
    window.setTimeout(() => {
      if (document.hidden || document.querySelector('dialog[open], .is-open') || /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName)) return;
      open();
    }, 10000);
  }
})();
